import { Column, Row, constants } from '@narvar/nth-grid';
import styled from 'styled-components';

const smallBreakpoint = constants.breakpointMinWidths[constants.WIDTH_SM];

interface ContainerProps {
  s?: React.CSSProperties;
}

export const Container = styled.div<ContainerProps>`
  background-color: ${({ s }) => s?.backgroundColor};
  border-bottom-color: ${({ s }) => s?.borderBottomColor ?? '#E0E0E0'};
  border-bottom-style: ${({ s }) => s?.borderBottomStyle ?? 'solid'};
  border-bottom-width: ${({ s }) => s?.borderBottomWidth ?? '1px'};
  border-left-color: ${({ s }) => s?.borderLeftColor ?? '#E0E0E0'};
  border-left-style: ${({ s }) => s?.borderLeftStyle ?? 'solid'};
  border-left-width: ${({ s }) => s?.borderLeftWidth ?? '1px'};
  border-right-color: ${({ s }) => s?.borderRightColor ?? '#E0E0E0'};
  border-right-style: ${({ s }) => s?.borderRightStyle ?? 'solid'};
  border-right-width: ${({ s }) => s?.borderRightWidth ?? '1px'};
  border-top-color: ${({ s }) => s?.borderTopColor ?? '#E0E0E0'};
  border-top-style: ${({ s }) => s?.borderTopStyle ?? 'solid'};
  border-top-width: ${({ s }) => s?.borderTopWidth ?? '1px'};

  padding: 1rem;
  @media (min-width: ${smallBreakpoint}) {
    padding: 1rem 2rem;
  }
`;

export const CollapsedRow = styled(Row)`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  @media (min-width: ${smallBreakpoint}) {
    align-items: center;
  }
`;

export const AddressRow = styled(Row)`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  @media (min-width: ${smallBreakpoint}) {
    align-items: center;
    flex-direction: row;
  }
`;

export const DistanceWrapper = styled(Column)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 0.25rem;
  @media (min-width: ${smallBreakpoint}) {
    justify-content: flex-end;
    margin-top: 0;
  }
`;

export const NameWrapper = styled(Column)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 0.25rem;
  @media (min-width: ${smallBreakpoint}) {
    margin-bottom: 0;
  }
`;

export const ActionsRow = styled(Row)`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  @media (min-width: ${smallBreakpoint}) {
    align-items: center;
    flex-direction: row;
    margin-top: 1rem;
  }
`;

export const VisibleDivSmall = styled.div`
  display: none;
  @media (min-width: ${smallBreakpoint}) {
    display: block;
  }
`;

export const PhoneWrapper = styled(Column)`
  margin-top: 1rem;
  @media (min-width: ${smallBreakpoint}) {
    margin-top: 0;
  }
`;

export const ButtonWrapper = styled(Column)`
  margin-top: 1rem;
  @media (min-width: ${smallBreakpoint}) {
    margin-top: 0;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  max-width: 3.5rem;
  height: 3.5rem;
`;
